class Header {
  constructor(element) {
    this.el = element;
    this.ui = {
      togglers: this.el.querySelectorAll('.js-header-toggler'),
      targets: this.el.querySelectorAll('.js-header-target'),
      doc: document,
      win: window,
      body: document.body,
    };
    this.elements = this.gatherElements(this.ui.togglers);
    this.cssState = {
      active: 'is-active',
      open: 'is-open',
    };
    this.currentOpenTarget = '';
    this.currentOpenSubTarget = '';

    this.ui.togglers.forEach(toggler =>
      toggler.addEventListener('click', this.handleTogglerClick.bind(this))
    );
    this.ui.doc.addEventListener('click', this.handleOuterClick.bind(this));
    this.ui.targets.forEach(target =>
      target.addEventListener('click', this.preventBubbling)
    );
    document.addEventListener('header.open', this.openTarget.bind(this));
    document.addEventListener('header.close', this.closeTarget.bind(this));
    document.addEventListener('header.closeSubTarget', event => {
      this.currentOpenSubTarget = event.detail;
    });

    this.ui.doc.addEventListener('keydown', e => {
      if (e.keyCode === 27) {
        if (this.currentOpenSubTarget) {
          document
            .querySelector(`[data-target='${this.currentOpenSubTarget}']`)
            .focus();
          this.currentOpenSubTarget = '';
        } else {
          document
            .querySelector(`[data-target='${this.currentOpenTarget}']`)
            .focus();
        }
        this.closeTarget(this.currentOpenTarget);
      }
    });
  }

  gatherElements(togglers) {
    const elements = {};
    togglers.forEach(el => {
      const id = el.dataset.target;
      const target = document.querySelector(id);
      const focus = target.querySelector(el.dataset.focusElement);
      elements[id] = {
        toggler: el,
        target: target,
        focus: focus,
        blockScroll: el.dataset.blockScroll !== undefined,
      };
    });
    return elements;
  }

  handleTogglerClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const el = e.currentTarget;
    const id = el.dataset.target;
    if (el.classList.contains(this.cssState.active)) {
      this.closeTarget({ detail: id });
    } else {
      this.openTarget({ detail: id });
    }
  }

  openTarget(event) {
    const id = event.detail;
    if (id !== this.currentOpenTarget) {
      this.closeTarget({detail: this.currentOpenTarget});
      this.currentOpenTarget = id;
      this.elements[id].toggler.classList.add(this.cssState.active);
      this.elements[id].target.classList.add(this.cssState.open);
      this.focusFirstElement(this.elements[id].focus, this.elements[id].target);
      if (this.elements[id].blockScroll) {
        document.body.classList.add("is-modal");
        this.blockScroll(true);
      }
    }
  }

  closeTarget(event) {
    if (event.detail) {
      let id = event.detail;
      this.currentOpenTarget = '';
      const closeEvent = new CustomEvent('header.closing', { detail: id });
      document.dispatchEvent(closeEvent);
      this.elements[id].toggler.classList.remove(this.cssState.active);
      this.elements[id].target.classList.remove(this.cssState.open);
      if (this.elements[id].blockScroll) {
        document.body.classList.remove("is-modal");
        this.blockScroll(false);
      }
    }
  }

  focusFirstElement(element, parent) {
    if (element) {
      parent.addEventListener('transitionend', () => {
        element.focus();
      });
    }
  }

  handleOuterClick() {
    this.closeTarget(this.currentOpenTarget);
  }

  preventBubbling(e) {
    e.stopPropagation();
  }

  blockScroll(block = true) {
    if (block) {
      const scrollPos = this.ui.win.scrollY;
      this.ui.body.style.position = 'fixed';
      this.ui.body.style.top = `-${scrollPos}px`;
      this.ui.body.style.left = 0;
      this.ui.body.style.right = 0;
    } else {
      const scrollPos = parseInt(this.ui.body.style.top) * -1;
      this.ui.body.removeAttribute('style');
      this.ui.win.scrollTo(0, scrollPos);
    }
  }
}
export default Header;
